<template>
  <el-calendar
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot
      slot="header"
      name="header"
    />
    <slot
      slot="headerLeft"
      name="headerLeft"
    />
    <slot
      slot="headerRight"
      name="headerRight"
    />
  </el-calendar>
</template>

<script>
import ElCalendar from 'vue-xpc/src/element-ui/packages/calendar/src/main.vue'
export default {
  name: 'RtCalendar',
  components: {
    ElCalendar
  },
  provide () {
    return {
      'rtCalendar': this
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtCalendar.vue?62e314af